document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hover-slider]').forEach(slider => {
    const slides = slider.querySelectorAll('.hover-slide');
    const dots = slider.querySelectorAll('.dot');

    if (slides.length <= 1) return;

    let index = 0;
    let interval;

    const show = i => {
      slides.forEach(s => s.classList.remove('is-active'));
      dots.forEach(d => d.classList.remove('active'));
      slides[i].classList.add('is-active');
      dots[i]?.classList.add('active');
    };

    slider.addEventListener('mouseenter', () => {
      interval = setInterval(() => {
        index = (index + 1) % slides.length;
        show(index);
      }, 900);
    });

    slider.addEventListener('mouseleave', () => {
      clearInterval(interval);
      index = 0;
      show(0);
    });
  });
});
